"use client";

import React from "react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function About() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="18004" id="overview-of-input-analysis" className="bg-background py-24" aria-labelledby="about-heading">
      <div ref={ref} className={`mx-auto max-w-[800px] px-6 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 id="about-heading" className="font-default text-3xl md:text-4xl font-bold text-primary tracking-tight">
          Overview of Input Analysis
        </h2>

        <Separator className="bg-chart-2 mx-auto my-8 h-0.5 w-20" />

        <div className="font-default text-lg font-normal leading-relaxed text-foreground/80 space-y-6">
          <p>
            Our clinical assessment methodology is built on a foundation of rigorous diagnostic 
            standards and patient-centered care. We utilize state-of-the-art diagnostic 
            technology to gather precise physiological data, allowing our specialists to 
            develop highly targeted treatment strategies that address the root cause 
            of your concerns with clinical precision.
          </p>
          <p>
            Navigating modern healthcare requires more than just clinical skill; it 
            demands a commitment to data-driven decision making. Whether evaluating 
            complex neurological patterns or assessing musculoskeletal health, our 
            analysis provides the clarity needed to make informed choices about your 
            long-term wellness and recovery journey while reducing patient anxiety.
          </p>
          <p>
            We take pride in maintaining a therapeutic environment that prioritizes 
            transparency and expertise. From your initial consultation to the detailed 
            review of your results, our goal is to provide a seamless experience that 
            empowers you with the knowledge and confidence to move forward with your 
            health goals under the guidance of our specialist team.
          </p>
        </div>
      </div>
    </section>;
}